var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sip-file-upload" },
    [
      !_vm.disableUpload
        ? _c("file-dropzone", {
            ref: "dropzone",
            attrs: {
              "button-text": _vm.buttonText,
              accept: _vm.acceptAttr,
              disabled: _vm.isUploadDisabled,
            },
            on: { selected: _vm.onFileSelected },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("file-upload-progress", {
        staticClass: "sip-file-upload__progress",
        attrs: { progress: _vm.progress },
      }),
      _vm._v(" "),
      _vm.progress || _vm.isFileSelected
        ? _c(
            "button",
            {
              staticClass: "btn btn-sm sip-file-upload__cancel",
              attrs: { type: "button" },
              on: { click: _vm.cancelUpload },
            },
            [
              _c("em", { staticClass: "icon ni ni-cross" }),
              _vm._v(" " + _vm._s(_vm.trans("general.cancel_upload")) + "\n  "),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.uploaded_files && _vm.uploaded_files.length
        ? _c(
            "ul",
            { staticClass: "sip-file-upload__list" },
            _vm._l(_vm.uploaded_files, function (uploaded_file) {
              return _c(
                "li",
                { key: uploaded_file.id, staticClass: "sip-file-upload__item" },
                [
                  !_vm.disableDelete
                    ? _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "confirm",
                              rawName: "v-confirm",
                              value: { ok: _vm.confirmDelete(uploaded_file) },
                              expression: "{ok: confirmDelete(uploaded_file)}",
                            },
                          ],
                          staticClass: "sip-file-upload__remove",
                        },
                        [
                          _c("i", {
                            staticClass: "fas fa-times pointer text-danger",
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("i", {
                    class: ["file-icon", "fas", uploaded_file.file_info.icon],
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "sip-file-upload__name" }, [
                    _vm._v(_vm._s(uploaded_file.user_filename)),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "sip-file-upload__size" }, [
                    _vm._v(_vm._s(uploaded_file.file_info.size)),
                  ]),
                ]
              )
            }),
            0
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }